import React from "react";
import ReactDOM from "react-dom";
import { CalendarDays, CalendarPlus } from "lucide-react";
import { t } from "../../utils/i18n";
import PayRuleCallout from "./PayRuleCallout";

// Premier écran du parcours "Date" — "Un rendez-vous ?" — recette exacte des bottom-sheets
// existantes de l'app (voir WelcomePopup.tsx) : fond blanc, coins très arrondis en haut
// uniquement, ombre du fond assombri, X discret.
export default function DatePromptSheet({ lang, onInvite, onClose }: { lang: string; onInvite: () => void; onClose: () => void }) {
  // Portail direct sur document.body — même bug/fix que PhotoLightbox.tsx : le conteneur mobile
  // de Layout.tsx utilise WebkitOverflowScrolling:"touch", et sur Safari iOS un position:fixed
  // descendant d'un tel ancêtre se positionne par rapport à TOUT son contenu scrollable plutôt
  // qu'au vrai viewport — la feuille se retrouvait très bas, hors écran, bouton "suivant" inclus.
  return ReactDOM.createPortal(
    <div onClick={onClose} style={{ position: "fixed", inset: 0, backgroundColor: "rgba(0,0,0,0.5)", zIndex: 3000, display: "flex", alignItems: "flex-end", justifyContent: "center" }}>
      <div onClick={e => e.stopPropagation()} style={{ backgroundColor: "white", borderRadius: "24px 24px 0 0", padding: 24, width: "100%", maxWidth: 480, maxHeight: "88vh", overflowY: "auto", boxSizing: "border-box" }}>
        <div style={{ display: "flex", justifyContent: "flex-end", marginBottom: 4 }}>
          <button onClick={onClose} style={{ border: "none", background: "none", cursor: "pointer", fontSize: 20, color: "#999", padding: 0, lineHeight: 1 }}>✕</button>
        </div>
        <div style={{ display: "flex", justifyContent: "center", marginBottom: 16 }}>
          <div style={{ width: 44, height: 44, borderRadius: "50%", backgroundColor: "#f5f5f5", display: "flex", alignItems: "center", justifyContent: "center" }}>
            <CalendarDays size={22} color="#0a0a0a" />
          </div>
        </div>
        <div style={{ fontSize: 19, fontWeight: 800, textAlign: "center", marginBottom: 8 }}>{t(lang, "date_prompt_title")}</div>
        <div style={{ fontSize: 13.5, color: "#666", textAlign: "center", lineHeight: 1.6, marginBottom: 18 }}>{t(lang, "date_prompt_body")}</div>
        <PayRuleCallout lang={lang} variant="inviter" />
        <button onClick={onInvite} style={{ width: "100%", display: "flex", alignItems: "center", justifyContent: "center", gap: 8, marginTop: 18, padding: "14px", borderRadius: 14, border: "none", backgroundColor: "#0a0a0a", color: "white", fontSize: 14, fontWeight: 700, cursor: "pointer" }}>
          <CalendarPlus size={17} />
          <span style={{ textTransform: "uppercase", letterSpacing: 0.3 }}>{t(lang, "date_prompt_cta")}</span>
        </button>
        <button onClick={onClose} style={{ width: "100%", marginTop: 10, padding: "10px", border: "none", background: "none", color: "#999", fontSize: 12.5, fontWeight: 600, cursor: "pointer" }}>
          {t(lang, "date_prompt_later")}
        </button>
      </div>
    </div>,
    document.body
  );
}
